'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _versionManager = require('../versionManager.js');

var _versionManager2 = _interopRequireDefault(_versionManager);

var _proGalleryVersionManager = require('../proGalleryVersionManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsVersionManager = function () {
  function SettingsVersionManager(proGallertVersionManager) {
    (0, _classCallCheck3.default)(this, SettingsVersionManager);

    this.pgVersionManager = proGallertVersionManager || _proGalleryVersionManager.pgVersionManager;
  }

  (0, _createClass3.default)(SettingsVersionManager, [{
    key: 'newMobileSettings',
    value: function newMobileSettings() {
      return this.pgVersionManager.getVersion('settings') !== _versionManager2.default.Versions.min;
    }
  }]);
  return SettingsVersionManager;
}();

var settingsVersionManager = new SettingsVersionManager();
module.exports = { settingsVersionManager: settingsVersionManager, SettingsVersionManager: SettingsVersionManager };